
import React from 'react';
import { Button } from '@/components/ui/button';
import { Grid, List } from 'lucide-react';

export type ViewType = 'card' | 'list';

interface ViewToggleProps {
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
}

const ViewToggle = ({ currentView, onViewChange }: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant={currentView === 'card' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewChange('card')}
        className="flex items-center gap-1"
      >
        <Grid size={16} />
        <span>Cards</span>
      </Button>
      <Button
        variant={currentView === 'list' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewChange('list')}
        className="flex items-center gap-1"
      >
        <List size={16} />
        <span>List</span>
      </Button>
    </div>
  );
};

export default ViewToggle;
